import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import classNames from 'classnames';

import { RegistrationQuestion, QuestionType } from '../../../../../../types/working-model';
import Icon, { COLORS, ICONS } from '../../../../../general-ui/icon';
import PillToggle from '../../../../../general-ui/pill-toggle/pill-toggle';
import Switch from '../../../../../general-ui/switch/switch';

const QuestionTypeMap = {
	[QuestionType.text]: "Text field",
	[QuestionType.textarea]: "Text area",
	[QuestionType.select]: "Dropdown list",
	[QuestionType.checkbox]: "Checkbox",
	[QuestionType.numeric]: "Numeric Field",
	[QuestionType.date]: "Date Field",
	[QuestionType.email]: "Email Field",
};

interface ISortableRegistrationQuestionProps {
	question: RegistrationQuestion;
	id: string;
	selectedIds: number[];
	handleToggleQuestion: (value: RegistrationQuestion, on: boolean) => void;
	requiredQuestions: number[];
	setQuestionRequired: (question: number, value: number) => void;
	setEditingQuestion: (question: RegistrationQuestion) => void;
}

const SortableRegistrationQuestion: React.FC<ISortableRegistrationQuestionProps> = (props) => {
	const {
		question,
		id,
		selectedIds,
		handleToggleQuestion,
		requiredQuestions,
		setQuestionRequired,
		setEditingQuestion,
	} = props;

	const {
		attributes,
		listeners,
		setNodeRef,
		transform,
	} = useSortable({ id });

	const style = {
		transform: CSS.Transform.toString(transform),
		transition: 'none',
	};

	const isOn = selectedIds?.includes(question.registration_question) ?? false;

	return (
		(
			<div key={question.registration_question}
				ref={setNodeRef}
				style={style}
				className={classNames("registration-option", { 'on': selectedIds?.includes(question.registration_question) ?? false, dragging: attributes["aria-pressed"] })}
			>
				{ isOn ? (
					<div className="drag-handle" {...attributes} {...listeners}>
						<Icon name={ICONS.DRAG_HANDLE} size={12} color={COLORS.GRAY} />
					</div>
				) : <div />
				}
				<Switch
					on={isOn}
					value={question}
					onClick={handleToggleQuestion}
				/>
				<p className="registration-question-label">{question.name}</p>
				<select disabled={!isOn} className="registration-question-type">
					<option value="">{QuestionTypeMap[question.type]}</option></select>
				<PillToggle
					selected={requiredQuestions.includes(question.registration_question) ? 1 : 0}
					value={question.registration_question}
					onClick={setQuestionRequired}
					disabled={!selectedIds?.includes(question.registration_question) ?? true}
				/>
				{!question.global && <button onClick={() => setEditingQuestion(question)} className="round"><Icon name={ICONS.EDIT} size={10} color={COLORS.WHITE} /></button>}
			</div>
		)
	);
};

export default SortableRegistrationQuestion;